if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Keep console.warn and console.error
}

import "./registerComponentHooks";
import Vue from "vue";
import App from "./App.vue";
import Axios, { AxiosRequestConfig } from "axios";
import router from "./router";
import store from "./store";
import VueEvents from "vue-events";
import Vuelidate from "vuelidate";
import vSelect from "vue-select";
import Notifications from "vue-notification";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import { UserService } from "@/services/userService";
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import { toastService } from "@/services/toastService";
// Try this in main.ts first:


import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = false;
Vue.use(VueEvents);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(PerfectScrollbar);
Vue.component("v-select", vSelect);
Vue.use(Notifications);

//INTERCEPTORS
Axios.interceptors.request.use(
  (config) => {
    if (!UserService.isAuthenticated()) return config;

    const account = UserService.getAccount();
    // @ts-ignore
    config.headers.Authorization = `Bearer ${account?.token}`;

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    // Keep the original error structure - don't transform it
    if (error.response && error.response.status) {
      console.error(error.response.data?.Message);
      switch (error.response.status) {
        case 400:
          //do something
          break;
        case 401:
          console.error("session expired");
          UserService.logout();
          // Only redirect if not already on login page
          if (router.currentRoute.name !== "Login") {
            router.push({ name: "Login" });
          }
          break;
        case 403:
          console.error("Access Denied");
          break;
        case 404:
          console.error("page not exist");
          break;
      }
      // Return the original error, not error.response
      return Promise.reject(error);
    } else {
      // Handle network errors, CORS errors, etc.
      console.error("Network error or no response:", error.message);
      return Promise.reject(error);
    }
  }
);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

toastService.init();